/**
 * Team member field mappings and configurations
 */

/**
 * Mapping of team member fields with their configurations
 * Ordered as: Email Of Lead (Required), Name, Number, Job Title, Company, Website, Location
 */
export const TEAM_MEMBER_FIELDS = {
    'emailOfLead': {
        label: 'Email Of Lead',
        key: 'emailOfLead',
        required: true,
        description: 'Email address of the lead contact',
        validate: (value) => {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return value ? emailRegex.test(value) : false;
        }
    },
    'name': {
        label: 'Name',
        key: 'name',
        required: false,
        description: 'Full name of the lead',
        validate: (value) => {
            return value ? /^[a-zA-Z\s'-]+$/.test(value) : true;
        }
    },
    'number': {
        label: 'Number',
        key: 'number',
        required: false,
        description: 'Contact phone number',
        validate: (value) => {
            // For CSV import, accept any phone number format
            return true;
        }
    },
    'jobtitle': {
        label: 'Job Title',
        key: 'jobtitle',
        required: false,
        description: 'Professional title or position'
    },
    'company': {
        label: 'Company',
        key: 'company',
        required: false,
        description: 'Organization or company name',
        validate: (value) => {
            return value ? value.length <= 100 : true;
        }
    },
    'website': {
        label: 'Website',
        key: 'website',
        required: false,
        description: 'Personal or company website',
        validate: (value) => {
            const websiteRegex = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})[/\w .-]*\/?$/;
            return value ? websiteRegex.test(value) : true;
        }
    },
    'location': {
        label: 'Location',
        key: 'location',
        required: false,
        description: 'Geographic location or address'
    }
};

/**
 * Get required team member fields
 * @returns {Array} Array of required field keys
 */
export const getRequiredFields = () => {
    return Object.entries(TEAM_MEMBER_FIELDS)
        .filter(([_, config]) => config.required)
        .map(([key, _]) => key);
};

/**
 * Get all team member field keys
 * @returns {Array} Array of all field keys
 */
export const getAllFields = () => {
    return Object.keys(TEAM_MEMBER_FIELDS);
};
